import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import PageRecipientDetails from '@/plugins/graphql/queries/v2/page-recipient.gql';
import { PageRecipientDetailsModel } from '@/helpers/entities/models/PageRecipientDetailsModel';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import Avatar from '@/components/avatar/Index.vue';
let CustomerCard = class CustomerCard extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.recipient = null;
    }
    onChanged() {
        this.$apollo.queries.recipient.refetch();
    }
    avatarSize() {
        if (this.recipient?.defaultProfilePic?.includes('messenger-logo')) {
            return 97;
        }
        return 74;
    }
};
__decorate([
    Prop({ type: String, required: true })
], CustomerCard.prototype, "recipientUuid", void 0);
__decorate([
    Watch('recipientUuid')
], CustomerCard.prototype, "onChanged", null);
CustomerCard = __decorate([
    Component({
        apollo: {
            recipient: {
                query: PageRecipientDetails,
                variables() {
                    return {
                        pageRecipientUuid: this.recipientUuid,
                    };
                },
                update(data) {
                    return new PageRecipientDetailsModel(data.pageRecipient);
                },
                fetchPolicy: 'cache-and-network',
            },
        },
        components: {
            Avatar,
        },
    })
], CustomerCard);
export default CustomerCard;
